import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { BookOpen, TrendingUp, ShieldCheck } from 'lucide-react';
export function Hero() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-white pt-24 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden" data-id="element-140">
      <div className="max-w-6xl mx-auto" data-id="element-141">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-142">
          <div className="flex-1 text-center lg:text-left" data-id="element-143">
            <FadeIn data-id="element-144">
              <div className="inline-block bg-brand-green text-white font-bold px-8 py-3.5 rounded-full text-lg md:text-xl mb-6 border border-brand-gold/40 tracking-widest uppercase shadow-xl" data-id="element-145">
                INGRESOS ONLINE DESDE CASA
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-146">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-green leading-tight mb-6" data-id="element-147">
                Cómo crear tu primer ingreso desde casa vendiendo en Amazon FBA
                <span className="block text-2xl md:text-3xl font-medium text-brand-text/70 mt-4 font-sans" data-id="element-148">
                  (aunque empieces desde cero y sin experiencia)
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-149">
              <p className="text-lg md:text-xl text-brand-text mb-8 leading-relaxed" data-id="element-150">
                Aprende paso a paso qué vender, cómo empezar correctamente y
                cómo lanzar tu producto evitando errores que hacen perder
                dinero.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-151">
              <div className="bg-brand-beige/50 p-6 rounded-xl mb-10 border border-brand-gold/20" data-id="element-152">
                <p className="text-brand-text font-medium flex items-start gap-3" data-id="element-153">
                  <span className="text-xl" data-id="element-154">👉</span>
                  <span data-id="element-155">
                    No estás comprando solo un ebook… Estás accediendo a un
                    sistema completo diseñado para ayudarte a empezar con
                    claridad y seguridad.
                  </span>
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-156">
              <Button onClick={goToCheckout} className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-157">
                QUIERO EMPEZAR AHORA
              </Button>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-158">
            <FadeIn delay={0.3} data-id="element-159">
              <img src="https://cdn.magicpatterns.com/uploads/91JGFMLPCxeBmQ6GN9u4tX/portada_como_vender_en_amazon_comprimida_.png" alt="Cómo Vender en Amazon FBA Desde Cero (2026) - Guía Completa" className="w-full h-auto rounded-2xl shadow-2xl object-contain" data-id="element-160" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}